// store/modules/detectOnline.js (or wherever you keep it)

const state = {
  onlineUsers: [],           // only users with status: true
  onlineUserIds: new Set(),  // for O(1) lookup — super fast
};

const mutations = {
  setOnlineUsers(state, users) {
    // users = array of user objects that have status === true
    state.onlineUsers = [...users];
    state.onlineUserIds = new Set(users.map(u => u.id));
  },

  addOnlineUser(state, user) {
    if (state.onlineUserIds.has(user.id)) return; // already there

    state.onlineUsers.push(user);
    state.onlineUserIds.add(user.id);
  },

  removeOnlineUser(state, userOrId) {
    const id = typeof userOrId === 'object' ? userOrId.id : userOrId;

    if (!state.onlineUserIds.has(id)) return;

    state.onlineUsers = state.onlineUsers.filter(u => u.id !== id);
    state.onlineUserIds.delete(id);
  },

  clearOnlineUsers(state) {
    state.onlineUsers = [];
    state.onlineUserIds.clear();
  }
};

const getters = {
  isUserOnline: (state) => (userId) => {
    return state.onlineUserIds?.has(userId) ?? false;
  },

  onlineUsersList: (state) => state.onlineUsers,
};

export default {
  namespaced: true, // RECOMMENDED if not already
  state,
  mutations,
  getters,
};